import { PERMISSION_MANAGE_SHOPS } from 'app-support/permissions/Permissions'
import ConversionList from './List'
import { conversionRoute } from 'routes/routeNames'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { Switch } from 'react-router-dom'

const ConversionContainer: React.FC<{}> = () => (
  <Switch>
    <PermissionRoute permission={PERMISSION_MANAGE_SHOPS} exact path={conversionRoute} component={ConversionList} />
  </Switch>
)

export default ConversionContainer
